const getters = {
  component: (state) => state.component,
  moduleStatus: (state) => state.moduleStatus,
  module: (state) => state.module,
  topic: (state) => state.topic,
  userInfo: (state) => state.userInfo,
  isLoading: (state) => state.isLoading,
  wapAllQuestion: (state) => state.wapAllQuestion,
  qTime: (state) => state.qTime,
  questionId: (state) => state.questionId,
  showVideoTip: (state) => state.showVideoTip,
  showNoticeTip: (state) => state.showNoticeTip,
  showTimeoutNotice: (state) => state.showTimeoutNotice,
  shareData: (state) => state.shareData,
  stopTimer: (state) => state.stopTimer,
  routeName: (state) => state.routeName,
  reportInfo: (state) => state.reportInfo,
  reportQuesNum: (state) => state.reportQuesNum,
  currentIndex: (state) => state.currentIndex,
  autoRobot: (state) => state.autoRobot,
};
export default getters;
